import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const AdminOrdersPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        {t('navigation.orders')} - Admin
      </Typography>
      <Typography variant="body1">
        Order management and monitoring interface will be implemented here.
      </Typography>
    </Box>
  );
};

export default AdminOrdersPage;